import { render, staticRenderFns } from "./bloodEditFollowUp.vue?vue&type=template&id=0defdedc&scoped=true"
import script from "./bloodEditFollowUp.vue?vue&type=script&lang=js"
export * from "./bloodEditFollowUp.vue?vue&type=script&lang=js"
import style0 from "./bloodEditFollowUp.vue?vue&type=style&index=0&id=0defdedc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0defdedc",
  null
  
)

export default component.exports